import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-detail',
  standalone: false,
  
  templateUrl: './payment-detail.component.html',
  styles: ``
})
export class PaymentDetailComponent {

}
